/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const TimestampLessThanOrEqual: core.serialization.ObjectSchema<
    serializers.TimestampLessThanOrEqual.Raw,
    Truvity.TimestampLessThanOrEqual
> = core.serialization.object({
    value: core.serialization.date(),
});

export declare namespace TimestampLessThanOrEqual {
    export interface Raw {
        value: string;
    }
}
